import React from 'react'
import SideBarLayout from "../../../layout/side-bar-layout"
import {TITLE_DESIGN_SYSTEM_PAGE} from "../../../../utils/constants"
import {Box} from "@mui/material"
import TabsWrappedLabel from "../../../components/tabs/tabs-component"
import TextFieldInputPage from "./components/textfield"
import GridRadioButtonPage from "./components/gridradiobutton"
import GenericRadioButtonPage from "./components/radiobutton"
import SelectInputPage from "./components/select"
import AutocompleteInputPage from "./components/autocomplete"
import DynamicTextareaPage from "./components/dynamic-textarea"

const InputPage = () => {
    const TITLE_PAGE = `${TITLE_DESIGN_SYSTEM_PAGE} | Inputs`

    return <SideBarLayout
        header
        title={TITLE_PAGE}
        headerTitle={TITLE_PAGE}
    >
        <Box sx={{width: "100%"}}>
            <TabsWrappedLabel
                tabs={[
                    {
                        value: "textfield",
                        label: "TextField",
                        content: <Box mt={2}><TextFieldInputPage /></Box>,
                    },
                    {
                        value: "gridradiobutton",
                        label: "Grid Radio Button",
                        content: <Box mt={2}><GridRadioButtonPage /></Box>,
                    },
                    {
                        value: "radiobutton",
                        label: "Generic Radio Button",
                        content: <Box mt={2}><GenericRadioButtonPage /></Box>,
                    },
                    {
                        value: "select",
                        label: "Select",
                        content: <Box mt={2}><SelectInputPage /></Box>,
                    },
                    {
                        value: "autocomplete",
                        label: "AutoComplete",
                        content: <Box mt={2}><AutocompleteInputPage /></Box>,
                    },
                    {
                        value: "dynamic-textarea",
                        label: "Dynamic Textarea",
                        content: <Box mt={2}><DynamicTextareaPage /></Box>,
                    },
                ]}
            />
        </Box>
    </SideBarLayout>
}

export default InputPage
